<div class="xux-checkbox">
  <label [for]="'headerSelectAll'">
    <div class="checkbox-wrapper">
      <input
        type="checkbox"
        #headerSelectAllCheckbox
        [id]="'headerSelectAll'"
        [checked]="isEveryRowSelected$ | async"
        (change)="selectAllClick()"
      />
      <span class="checkmark" [class.indeterminate]="isIndeterminate$ | async"></span>
    </div>
  </label>
</div>
